const CampanhaPublicitariaCategoria = {
  OPORTUNIDADES: 1,
  BENEFICIOS: 2,
};

export default CampanhaPublicitariaCategoria;
